import styles from './ComingSoon.module.css'

function ComingSoon() {
  return (
    <div data-cy="coming-soon" className={styles.ComingSoon}>
      Coming Soon
    </div>
  )
}

export default ComingSoon
